<div class="flex flex-row mt-3">
  <div class="flex-auto">
    <div class="mt-2">
      <mat-radio-group [(ngModel)]="selectedAction" class="stock-management-radio-group" [disabled]="loadingRawMaterials">
        <div class="radio-card" [class.selected]="selectedAction === 'receiveInventory'">
          <mat-radio-button id="receive-inventory-radio" value="receiveInventory" [disableRipple]="true">
            <div class="radio-card-content">
              <mat-icon class="radio-card-icon">download</mat-icon>
              <span class="radio-card-label">{{ translationService.translate('receiveInventoryText') }}</span>
            </div>
          </mat-radio-button>
        </div>
        <div class="radio-card" [class.selected]="selectedAction === 'adjustInventory'">
          <mat-radio-button id="adjust-inventory-radio" value="adjustInventory" [disableRipple]="true">
            <div class="radio-card-content">
              <mat-icon class="radio-card-icon">tune</mat-icon>
              <span class="radio-card-label">{{ translationService.translate('adjustInventoryText') }}</span>
            </div>
          </mat-radio-button>
        </div>
      </mat-radio-group>

      <!-- Form (shown for both radio buttons) -->
      <div *ngIf="selectedAction" class="mt-2">
        <form [formGroup]="receiveInventoryForm">
          <!-- Loading bar for metadata -->
          <mat-progress-bar *ngIf="loadingStockData" mode="indeterminate" class="mb-2"></mat-progress-bar>
          <!-- Loading bar for raw materials -->
          <mat-progress-bar *ngIf="loadingRawMaterials" mode="indeterminate" color="accent" class="mb-2"></mat-progress-bar>

          <!-- Row 1: Plant | Raw Material Type -->
          <div class="form-row">
            <div class="w-full" id="plantField">
              <app-dropdown-search-single-select
                id="plant"
                label="{{ translationService.translate('plantCodeText') }}"
                emptyPlaceholder="{{ translationService.translate('plantCodeText') }}"
                placeholder="{{ translationService.translate('plantCodeText') }}"
                [formGroup]="receiveInventoryForm"
                formControlName="plant"
                [data]="plantOptionsFormatted"
              >
              </app-dropdown-search-single-select>
              <mat-error
                *ngIf="receiveInventoryForm.get('plant')?.invalid && receiveInventoryForm.get('plant')?.touched"
                class="field-error"
              >
                {{ translationService.translate('thisIsMandatoryFieldText') }}
              </mat-error>
            </div>

            <div class="w-full" id="rawMaterialTypeField">
              <app-dropdown-search-single-select
                id="rawMaterialType"
                label="{{ translationService.translate('rawMaterialTypeText') }}"
                emptyPlaceholder="{{ translationService.translate('rawMaterialTypeText') }}"
                placeholder="{{ translationService.translate('rawMaterialTypeText') }}"
                [formGroup]="receiveInventoryForm"
                formControlName="rawMaterialType"
                [data]="rawMaterialTypeOptions"
              >
              </app-dropdown-search-single-select>
              <mat-error
                *ngIf="receiveInventoryForm.get('rawMaterialType')?.invalid && receiveInventoryForm.get('rawMaterialType')?.touched"
                class="field-error"
              >
                {{ translationService.translate('thisIsMandatoryFieldText') }}
              </mat-error>
            </div>
          </div>

          <div class="form-row single-field">
            <div class="w-full" id="serialNumberField">
              <app-dropdown-search-single-select
                id="serialNumber"
                label="{{ translationService.translate('serialNumberText') }}"
                emptyPlaceholder="{{ translationService.translate('serialNumberText') }}"
                placeholder="{{ translationService.translate('serialNumberText') }}"
                [formGroup]="receiveInventoryForm"
                formControlName="serialNumber"
                [data]="serialNumberOptions"
              >
              </app-dropdown-search-single-select>
              <mat-error
                *ngIf="receiveInventoryForm.get('serialNumber')?.invalid && receiveInventoryForm.get('serialNumber')?.touched"
                class="field-error"
              >
                {{ translationService.translate('thisIsMandatoryFieldText') }}
              </mat-error>
            </div>
          </div>
          <div class="form-row single-field">
            <div class="w-full" id="descriptionField">
              <app-dropdown-search-single-select
                id="description"
                label="{{ translationService.translate('descriptionText') }}"
                emptyPlaceholder="{{ translationService.translate('descriptionText') }}"
                placeholder="{{ translationService.translate('descriptionText') }}"
                [formGroup]="receiveInventoryForm"
                formControlName="description"
                [data]="rawMaterialStockOptions"
              >
              </app-dropdown-search-single-select>
              <mat-error
                *ngIf="receiveInventoryForm.get('description')?.invalid && receiveInventoryForm.get('description')?.touched"
                class="field-error"
              >
                {{ translationService.translate('thisIsMandatoryFieldText') }}
              </mat-error>
            </div>
          </div>

          <!-- Row 4: Total Available Stock | Quantity/Weight to Receive -->
          <div class="form-row">
            <mat-form-field class="w-full read-only-field" id="totalAvailableStockField">
              <mat-label>{{ translationService.translate('totalAvailableStockText') }}</mat-label>
              <input
                subscriptSizing="dynamic"
                id="totalAvailableStock"
                matInput
                type="text"
                formControlName="totalAvailableStock"
                readonly
                [disabled]="loadingRawMaterials"
              />
            </mat-form-field>

            <mat-form-field class="w-full" id="quantityToReceiveField">
              <mat-label>{{ translationService.translate('quantityWeightToReceiveText') }}</mat-label>
              <input
                subscriptSizing="dynamic"
                id="quantityToReceive"
                matInput
                formControlName="quantityToReceive"
                placeholder="{{ this.getPlaceHolderText() }}"
                [disabled]="loadingRawMaterials"
              />
              <mat-error *ngIf="receiveInventoryForm.get('quantityToReceive')?.hasError('required')">
                {{ translationService.translate('thisIsMandatoryFieldText') }}
              </mat-error>
              <mat-error
                *ngIf="
                  selectedAction === 'receiveInventory' &&
                  (receiveInventoryForm.get('quantityToReceive')?.hasError('pattern') ||
                    receiveInventoryForm.get('quantityToReceive')?.hasError('min') ||
                    receiveInventoryForm.get('quantityToReceive')?.hasError('containsNegativeSign'))
                "
              >
                {{ translationService.translate('invalidQuantityText') }}
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Row 5: Comment (full width) -->
          <div class="form-row single-field">
            <mat-form-field class="w-full" id="commentField">
              <mat-label>{{ translationService.translate('commentText') }}</mat-label>
              <textarea
                subscriptSizing="dynamic"
                id="comment"
                matInput
                formControlName="comment"
                rows="2"
                maxlength="500"
                placeholder="{{ this.getCommentPlaceHolderText() }}"
                [disabled]="loadingRawMaterials"
              ></textarea>
            </mat-form-field>
          </div>

          <!-- Actions -->
          <div class="form-actions">
            <button
              id="clear-form-button"
              mat-flat-button
              color="accent"
              type="button"
              (click)="clearForm()"
              [disabled]="loadingRawMaterials"
            >
              <mat-icon>refresh</mat-icon>
              <span>{{ translationService.translate('clearFormText') }}</span>
            </button>
            <button
              id="submit-form-button"
              mat-flat-button
              color="primary"
              type="button"
              (click)="submitForm()"
              [disabled]="loadingRawMaterials"
            >
              <mat-icon>{{ selectedAction === 'adjustInventory' ? 'tune' : 'move_to_inbox' }}</mat-icon>
              <span>{{
                translationService.translate(selectedAction === 'adjustInventory' ? 'adjustInventoryText' : 'receiveInventoryText')
              }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
